import React, { FC } from 'react';
import Icon from '@ant-design/icons/lib';

const PasswordEyeSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width="16"
    height="16"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M15 4.01c-6.6 0-12.23 4.06-14.51 9.8 2.28 5.73 7.91 9.8 14.51 9.8 6.6 0 12.23-4.06 14.51-9.8C27.23 8.07 21.6 4.01 15 4.01Zm0 16.33c-3.64 0-6.6-2.93-6.6-6.53 0-3.61 2.96-6.53 6.6-6.53 3.64 0 6.6 2.92 6.6 6.53 0 3.6-2.96 6.53-6.6 6.53Zm0-10.45c-2.18 0-3.96 1.76-3.96 3.92 0 2.16 1.78 3.92 3.96 3.92s3.96-1.76 3.96-3.92c0-2.16-1.78-3.92-3.96-3.92Z" />
  </svg>
);

export const PasswordEyeIcon: FC = (props) => (
  <Icon component={PasswordEyeSvg} {...props} />
);
